import {Box, Pagination} from '@mui/material';
import React from 'react';
import {useDispatch, useSelector} from 'react-redux';
import {useParams} from 'react-router-dom';
import {getGaragesByBuilding} from '../../actions';
import {Filters} from '../../components';
import GaragesTable from '../../components/CustomTables/GaragesTable';
import useFilters from '../../utils/useFilters';

const GaragesTab = () => {
  const dispatch = useDispatch();
  const {id} = useParams();
  const {
    buildingGarages,
    garagesLoading,
    buildingGaragesPage,
    buildingGaragesTotalPages,
  } = useSelector(s => s.garages);
  const filters = useFilters(val => dispatch(getGaragesByBuilding(id, val)));

  const onPageChange = (e, value) => {
    dispatch(getGaragesByBuilding(id, {page: value, ...filters.filters}));
  };

  return (
    <>
      <Box position="absolute" zIndex={1}>
        <Filters m="0 !important" withSearch {...filters} />
      </Box>
      <GaragesTable garages={buildingGarages} loading={garagesLoading} />
      {buildingGaragesTotalPages > 1 && (
        <Box mt="1rem" display="flex" justifyContent="center">
          <Pagination
            count={buildingGaragesTotalPages}
            page={buildingGaragesPage}
            onChange={onPageChange}
          />
        </Box>
      )}
    </>
  );
};

export default GaragesTab;
